<template>
    <div class="cc-home">
        <div class="cc-sub-container index-top">
            <div class="cc-main-container">
                <div class="cc-header">
                    <div class="cc-header-left">
                        <img src="../../assets/logo.png" alt="">
                    </div>
                </div>
                <div class="cc-top-video">
                    <video
                        ref="mainBgVideo"
                        controlsList="nodownload"
                        poster="https://qiaojiang.bj.bcebos.com/fe/static/images/home/mobile-header-video-thumbnail.png"
                        src="https://qiaojiang.bj.bcebos.com/fe/static/images/home/mobile-header-video-v2.mp4"
                        playsInline="true"
                        webkit-playsinline="true"
                        x-webkit-airplay="allow"
                        x5-playsinline="true"
                        x5-video-player-type="h5"
                        x5-video-orientation="portraint"
                        t7-video-player-type="inline"
                        class="cc-video"
                        preload="auto"
                        muted
                        autoplay=""
                        loop=""
                        @loadedmetadata="videoLoaded"
                    ></video>
                </div>
                <div class="cc-main-content">
                    <div class="cc-main-content-left">
                        <div class="main-title">
                            <p>AIGC赋能</p>
                            <p>营销创意新纪元</p>
                        </div>
                        <div class="main-desc">
                            汇聚百度全新AI技术，提供精准、创新、<br>引人入胜的多模态广告创意内容。
                        </div>
                    </div>
                </div>
                <div class="cc-main-cube"></div>
            </div>
        </div>
        <div>
            <cc-content :is-mobile="true"/>
            <cc-footer/>
        </div>
    </div>
</template>

<script>
import NavContent from './components/WiseContentV2.vue';
import WiseFooter from './components/WiseFooter.vue';

export default {
    name: 'mobilehome',
    components: {
        'cc-content': NavContent,
        'cc-footer': WiseFooter
    },
    methods: {
        videoLoaded() {
            const videoDom = this.$refs.mainBgVideo;
            if (videoDom != null) {
                videoDom.play();
            }
        }
    }
};
</script>

<style lang="less" scoped>
.cc-home {
    overflow-x: hidden;
    overflow-y: auto;
    // background-image: url('./assets/bannerBg.jpg');
    // background-repeat: repeat;
    background-color: linear-gradient(#D8EDFF, #FFFFFF);
}
.cc-main-container {
    width: 100%;
    margin: 0 auto;
    position: relative;
    height: 65.5rem;
    // background: url(./assets/mobilev2-top-bg.png) no-repeat;
    background-size: 100% 100%;
    overflow: hidden;
    .cc-header {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 5.5rem;
        background-color: #fff;
        &-left {
            img {
                height: 2.5rem;
            }
        }
    }
    .cc-top-video {
        position: absolute;
        height: 60rem;
        top: 5.5rem;
        left: 0;
        right: 0;
        bottom: 0;
        video {
            width: 100%;
            height: 100%;
        }
    }
    .cc-main-content {
        display: flex;
        position: absolute;
        z-index: 3;
        top: 5.5rem;
        width: 100%;
        height: auto;
        padding-top: 4rem;
        &-left {
            width: 100%;
            .main-title {
                font-style: normal;
                font-weight: 600;
                font-size: 4rem;
                line-height: 4.6rem;
                color: #000000;
                text-align: center;
            }
            .main-desc {
                font-style: normal;
                font-weight: 400;
                font-size: 1.6rem;
                line-height: 2.8rem;
                color: #282C33;
                margin-top: 1.2rem;
                text-align: center;
            }
        }
    }
    // .cc-main-cube {
    //     height: 45.8rem;
    //     width: 100%;
    //     background: url(./assets/mobilev2-top-cube.png) no-repeat;
    //     background-size: contain;
    //     background-position: center bottom;
    //     position: absolute;
    //     bottom: 1.3rem;
    //     left: 0;
    // }

}
.cc-home {
    /deep/ .cc-sub-container {
        &.topnav {
            display: none;
        }
        &.content {
            background-image: url('./assets/mobilev2-content-bg.png');
            height: 52rem;
        }
        .cc-content-container {
            width: 100%;
            height: auto;
            padding-top: 7.7rem;
            .cc-content-text {
                width: 37.5rem;
                text-align: center;
                margin: 0 auto;
                padding: 0 2.9rem;
                min-width: 0;
                .cc-content-title {
                    font-size: 3.2rem;
                    line-height: 4.5rem;
                }
                .cc-content-desc {
                    font-size: 1.6rem;
                    line-height: 2.2rem;
                    margin-top: 0.8rem;
                }
                .cc-nav-button {
                    display: inline-block;
                    height: 4rem;
                    width: 11.2rem;
                    font-size: 1.4rem;
                    line-height: 4rem;
                    border-radius: 3.2rem;
                    margin-top: 1.6rem;
                }
            }
            .cc-video-container {
                width: 100%;
                position: relative;
                right: 0;
                left: 0;
                top: 0;
                text-align: center;
                background-image: url('./assets/wiseVideoBg.png');
                height: 30.6rem;
                width: 100%;
                background-size: auto 36.1rem;
                background-position: center bottom;
                .cc-video {
                    margin: 0 auto;
                    width: auto;
                    height: calc(100% - 9.7rem);
                    top: unset;
                    left: 50%;
                    transform: translateX(-50%);
                    bottom: 5.2rem;
                    border-radius: 1.8rem;
                    border: 0 none;
                    outline: none;
                    &::-webkit-media-controls-volume-control-container,
                    &::-webkit-media-controls-mute-button,
                    &::-webkit-media-controls-enclosure,
                    &::-webkit-media-controls {
                        display: none !important;
                    }
                }
            }
        }
    }
}
</style>